/* eslint-disable no-shadow */ "use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
const $a5fd07fa01589658$var$SIZE_BOARD = 4;
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.board = initialState ? this.cloneBoard(initialState) : this.createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        if (this.status !== "playing") return false;
        let moved = false;
        for(let row = 0; row < $a5fd07fa01589658$var$SIZE_BOARD; row++){
            const newRow = this.board[row].filter((cell)=>cell !== 0);
            const merged = new Array(newRow.length).fill(false);
            for(let i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1] && !merged[i] && !merged[i + 1]) {
                newRow[i] *= 2;
                this.score += newRow[i];
                newRow.splice(i + 1, 1);
                merged[i] = true;
                moved = true;
            }
            while(newRow.length < $a5fd07fa01589658$var$SIZE_BOARD)newRow.push(0);
            if (this.board[row].some((cell, idx)=>cell !== newRow[idx])) {
                moved = true;
                this.board[row] = newRow;
            }
        }
        if (moved) {
            this.addRandomBox();
            if (this.checkWin()) return true;
            if (!this.hasEmptuCellsCantMove()) this.status = "lose";
        }
        return moved;
    }
    moveRight() {
        this.board = this.board.map((row)=>[
                ...row
            ].reverse());
        const moved = this.moveLeft();
        this.board = this.board.map((row)=>[
                ...row
            ].reverse());
        return moved;
    }
    moveUp() {
        this.transpose();
        const moved = this.moveLeft();
        this.transpose();
        return moved;
    }
    moveDown() {
        this.transpose();
        const moved = this.moveRight();
        this.transpose();
        return moved;
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        if (this.status === "idle") return "idle";
        for(let row = 0; row < $a5fd07fa01589658$var$SIZE_BOARD; row++)for(let col = 0; col < $a5fd07fa01589658$var$SIZE_BOARD; col++){
            if (this.board[row][col] === 2048) return "win";
        }
        if (!this.hasEmptuCellsCantMove()) {
            this.status = "lose";
            return "lose";
        }
        return "playing";
    }
    start() {
        if (this.status !== "idle") return;
        this.status = "playing";
        this.addRandomBox();
        this.addRandomBox();
    }
    restart() {
        this.board = this.createEmptyBoard();
        this.score = 0;
        this.status = "playing";
        this.addRandomBox();
        this.addRandomBox();
    }
    cloneBoard(board) {
        return board.map((row)=>[
                ...row
            ]);
    }
    createEmptyBoard() {
        return Array.from({
            length: $a5fd07fa01589658$var$SIZE_BOARD
        }, ()=>Array(4).fill(0));
    }
    addRandomBox() {
        const emptyCells = [];
        for(let row = 0; row < $a5fd07fa01589658$var$SIZE_BOARD; row++){
            for(let col = 0; col < $a5fd07fa01589658$var$SIZE_BOARD; col++)if (this.board[row][col] === 0) emptyCells.push({
                row: row,
                col: col
            });
        }
        if (emptyCells.length > 0) {
            const { row: row, col: col } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    hasEmptuCellsCantMove() {
        for(let row = 0; row < $a5fd07fa01589658$var$SIZE_BOARD; row++)for(let col = 0; col < $a5fd07fa01589658$var$SIZE_BOARD; col++){
            if (this.board[row][col] === 0) return true;
        }
        for(let row = 0; row < $a5fd07fa01589658$var$SIZE_BOARD; row++)for(let col = 0; col < $a5fd07fa01589658$var$SIZE_BOARD; col++){
            if (col < 3 && this.board[row][col] === this.board[row][col + 1]) return true;
            if (row < 3 && this.board[row][col] === this.board[row + 1][col]) return true;
        }
        return false;
    }
    checkWin() {
        for(let row = 0; row < $a5fd07fa01589658$var$SIZE_BOARD; row++){
            for(let col = 0; col < $a5fd07fa01589658$var$SIZE_BOARD; col++)if (this.board[row][col] === 2048) {
                this.status = "win";
                return true;
            }
        }
    }
    transpose() {
        this.board = this.board[0].map((_, col)=>// eslint-disable-next-line comma-dangle
            this.board.map((row)=>row[col]));
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button");
const $09e991522ca7e64e$var$gameField = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
        $09e991522ca7e64e$var$startButton.classList.add("start");
    }
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$updateMessage();
});
function $09e991522ca7e64e$var$updateBoard() {
    const board = $09e991522ca7e64e$var$game.getState();
    $09e991522ca7e64e$var$gameField.forEach((cell, index)=>{
        const row = Math.floor(index / 4);
        const col = index % 4;
        const value = board[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add(`field-cell--${value}`);
    });
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$updateMessage() {
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    const nowStatus = $09e991522ca7e64e$var$game.getStatus();
    if (nowStatus === "idle") $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
    else if (nowStatus === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    else if (nowStatus === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
}
document.addEventListener("keydown", (event)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    let moved = false;
    switch(event.key){
        case "ArrowLeft":
        case "a":
        case "A":
            moved = $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
        case "d":
        case "D":
            moved = $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
        case "w":
        case "W":
            moved = $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
        case "s":
        case "S":
            moved = $09e991522ca7e64e$var$game.moveDown();
            break;
    }
    if (moved) {
        $09e991522ca7e64e$var$updateBoard();
        $09e991522ca7e64e$var$updateMessage();
        if ($09e991522ca7e64e$var$game.getStatus() !== "idle" && $09e991522ca7e64e$var$startButton.textContent !== "Restart") {
            $09e991522ca7e64e$var$startButton.textContent = "Restart";
            $09e991522ca7e64e$var$startButton.classList.remove("start");
            $09e991522ca7e64e$var$startButton.classList.add("restart");
        }
    }
});
$09e991522ca7e64e$var$updateBoard();
$09e991522ca7e64e$var$updateMessage();


//# sourceMappingURL=index.2ebd44d0.js.map
